import React from 'react';
import { Box } from '@mui/material';
import VehicleDetailDashboard from '../../components/administracion/VehicleDetailDashboard';

const VehiculoDetallePage = () => { 

  return (
    <Box sx={{ p: 2 }}>
      <VehicleDetailDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de vehiculos:', newOrder);
        }}
      />
    </Box>
  );
};

export default VehiculoDetallePage;